import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { fecthIdFoodRandom } from '../services/fetchRandomIdRecipe';

function ExploreFoods() {
  const [idRecipe, setIdRecipe] = useState('');

  useEffect(() => {
    const getId = async () => {
      const data = await fecthIdFoodRandom();
      setIdRecipe(data);
    };
    getId();
  }, []);

  const history = useHistory();
  return (
    <div className="e-f-page">
      <Header Title="Explore Foods" />
      <div className="e-buttons">
        <button
          type="button"
          data-testid="explore-by-ingredient"
          className="e-btn"
          onClick={ () => history.push('/explore/foods/ingredients') }
        >
          By Ingredient
        </button>
        <button
          type="button"
          data-testid="explore-by-nationality"
          className="e-btn"
          onClick={ () => history.push('/explore/foods/nationalities') }
        >
          By Nationality
        </button>
        <button
          type="button"
          data-testid="explore-surprise"
          className="e-btn"
          onClick={ () => history.push(`/foods/${idRecipe}`) }
        >
          Surprise me!
        </button>
      </div>
      <Footer />
    </div>
  );
}

export default ExploreFoods;
